export const DATA_TID = {
  // 带条件选择的数字输入组件
  selectNumber: {
    leftSelect: 'select-number-left-select',
    inputLeft: 'select-number-input-left',
    inputRight: 'select-number-input-right',
  },
  // 通用下拉选择器
  select: {
    tagColorItem: 'select-tag-color-item',
  },
  // 自定义字段筛选项
  customField: {
    // 添加筛选
    addBtn: 'custom-field-add-btn',
    // 取消选择
    cancelBtn: 'custom-field-cancel-btn',
    // 确认选项
    confirmBtn: 'custom-field-confirm-btn',
    // 筛选项删除
    itemDelete: 'custom-field-item-delete',
    // 筛选项选择key
    itemKey: 'custom-field-item-key',
    // 筛选项选择操作
    itemOP: 'custom-field-item-op',
    // 筛选项选择value
    itemValue: {
      // 默认文字输入
      default: 'custom-field-item-value-string',
      // 输入数字
      number: 'custom-field-item-value-num',
      // 输入数字（开始范围）
      numberFrom: 'custom-field-item-value-num-from',
      // 输入数字（结束范围）
      numberTo: 'custom-field-item-value-num-to',
      // 输入多个值
      array: 'custom-field-item-value-array',
    },
  },
  trendInfo: {
    versionSelect: 'trend-info-version-select',
    timeSelect: 'trend-info-time-select',
  },
  analysisTrend: {
    // 上报趋势-指标选项框
    metricSelect: 'analysis-trend-metric',
    // 上报趋势-指标项选择
    metricOptions: 'analysis-trend-metric-ops',
  },
  analysisExitReason: {
    // 退出原因分析-指标选项框
    metricSelect: 'analysis-exit-reason-select',
  },
  analysisDistribution: {
    // 统计分布-维度选项框
    select: 'analysis-distri-select',
    // 统计分布-维度选择
    item: 'analysis-distri-item',
    // 统计分布-指标选项框
    metricSelect: 'analysis-distri-metric',
    // 统计分布-指标项
    metricOptions: 'analysis-distri-metric-ops',
  },
  analytics: {
    // 指标分析-图表
    launchAnalyticsOverview: 'launch-analytics-overview',
    // 指标分析-启动Span耗时
    launchAnalyticsTimeline: 'launch-analytics-timeline',
  },
  // 时间范围
  timeRangeCascade: 'timeRangeCascade',
  // app版本
  versionSelect: {
    singleAppVersion: 'single-appVersion',
    minAppVersion: 'min-app-version',
    maxAppVersion: 'max-app-version',
    wildcardAppVersion: 'wildcard-app-version',
  },
};
